//To use this, put this in your HTML:
//  <donor-add-edit #modalDonorAddEdit></donor-add-edit>
//Then put this in your TS file:
//  @ViewChild('modalDonorAddEdit') modalDonorAddEdit: DonorAddEditComponent;
//Then show it by calling this and passing the callback funtion into show():
//  this.modalDonorAddEdit.addDonor()
//
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { WebService, Donor, ApiResponse } from '../../shared/web-service/web.service';
import { Formatter } from '../../shared/utilities/utilities';

@Component({
  selector: 'donor-add-edit',
  templateUrl: './donor-add-edit.component.html',
  styleUrls: ['./donor-add-edit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DonorAddEditComponent implements OnInit {
  @ViewChild('modalAddEdit') modalAddEdit;
  callbackSave: Function;
  callbackCancel: Function;
  modalTitle: string;
  objectAddEdit: Donor;
  fedIdMask: string;
  oldDonorName: string;
  newDonorName: string;
  modalDonorPicker: any;
  msgBox: any;
  enableDonorEnvelope: boolean = JSON.parse(sessionStorage.enableDonorEnvelope); //used to show/hide field in the HTML

  constructor(private webService: WebService) {
    this.objectAddEdit = new Donor(0, '', '', '', '', '', null, '', '', 'US', '', '', '', true, '', null, true, '', null, true); //This is just a placeholder so we don't get an error on page load when the dialog form binds to this object.
  }

  ngOnInit() {
    $("#modalAddEditDonor .modal-dialog").css("maxWidth", "850px"); //By default the dialogs in this system are 500px wide, but we need our add/edit dialog to be wider.
  }

  // Open the dialog to add a donor. Pass in two optional parameters that are callback functions: the first will be called when this dialog is saved, and the second is called when it's cancelled. The first callback funtion has to be able to receive one parameter that is the new list of donors.
  addDonor(msgBox, modalDonorPicker, callbackSave?: Function, callbackCancel?: Function) {
    this.oldDonorName = "";
    this.msgBox = msgBox;
    this.modalDonorPicker = modalDonorPicker;
    this.callbackSave = callbackSave;
    this.callbackCancel = callbackCancel;
    this.objectAddEdit = new Donor(0, '', '', '', '', '', null, '', '', 'US', '', '', '', true, '', null, true, '', null, true);
    this.modalTitle = 'Add donor';
    this.onFedIdRadioChanged(this.objectAddEdit.hasSSN); //This will set the mask for the fed ID field.
    this.modalAddEdit.show();
    //We have to use setTimeout to set the focus to the first field because you can't set focus until it appears, which takes a moment.
    setTimeout(function () { $("#FirstName").focus() }, 300);
  }

  // Open the dialog to edit a donor. Pass in two optional parameters that are callback functions: the first will be called when this dialog is saved, and the second is called when it's cancelled. The first callback funtion has to be able to receive one parameter that is the new list of donors.
  editDonor(msgBox, obj: Donor, modalDonorPicker, callbackSave?: Function, callbackCancel?: Function) {
    this.oldDonorName = obj.firstName + " " + obj.lastName;
    this.msgBox = msgBox;
    this.modalDonorPicker = modalDonorPicker;
    this.callbackSave = callbackSave;
    this.callbackCancel = callbackCancel;
    this.objectAddEdit = jQuery.extend({}, obj); //This makes a copy of the donor data source for the dialog, so we aren't changing the original, in case the dialog is cancelled.
    this.modalTitle = 'Edit donor';
    setTimeout(() => { this.onFedIdRadioChanged(this.objectAddEdit.hasSSN); }, 100); //This will set the mask for the fed ID field. I use setTimeout because I was having issues where the textbox sometimes wouldn't display the correct value when it first came up. I am not sure why, but setting the mask here immediately interfered with it getting the value from the data source.
    this.modalAddEdit.show();
  }

  // Save donor to the DB and close the dialog.
  finishAddEditDonor() {
    // Any field that cannot be blank will have the attribute "data-not-blank-donor-dlg". If any of them are not filled in, we show the validation text and highlight the input by putting a class on them. Only save the data to the server and close the dialog if there are no validation errors.
    let blankError: boolean = false;
    $("#statementCell").removeClass("validation-error");
    $("#email").removeClass("validation-error");
    $("#phone").removeClass("validation-error");
    $("#federalID").removeClass("validation-error");
    $("#zipCode").removeClass("validation-error");

    $("*[data-not-blank-donor-dlg]").each(function (index) {
      if ($(this).val() == '' || !$(this).val()) {
        blankError = true;
        $(this).addClass("validation-error");
      }
      else {
        $(this).removeClass("validation-error");
      }
    });

    if (this.objectAddEdit.usePaperStatement == null) {
      blankError = true;
      $("#statementCell").addClass("validation-error");
    }

    if (blankError) {
      $("#validationErrorTdDonorDlg").text("Fields marked with * cannot be blank");
      $("#validationMsgDonorDlg").css("display", "");
      return;
    }

    if (this.objectAddEdit.email != '' && !Formatter.validateEmail(this.objectAddEdit.email)) {
      $("#email").addClass("validation-error");
      $("#validationErrorTdDonorDlg").text("Email address is invalid format.");
      $("#validationMsgDonorDlg").css("display", "");
      return;
    }

    //At one point I had implemented this such that you have to enter an email address if the donor is doing email statements. But then I changed my mind because of the scenario where there is a joint donor that doesn't actually want either paper or email statements, because they are sent to their spouse's address, so they could opt for email statements but give no email address.
    //if (this.objectAddEdit.email == '' && !this.objectAddEdit.usePaperStatement) {
    //  $("#email").addClass("validation-error");
    //  $("#validationErrorTdDonorDlg").text("Email address cannot be blank because you have chosen email statements.");
    //  $("#validationMsgDonorDlg").css("display", "");
    //  return;
    //}

    if ((!this.objectAddEdit.zipCode || this.objectAddEdit.zipCode == '') && !this.objectAddEdit.usePaperStatement) {
      $("#zipCode").addClass("validation-error");
      $("#validationErrorTdDonorDlg").text("Zip code cannot be blank because you have chosen email statements. The zip code is used as a security measure for email statements.");
      $("#validationMsgDonorDlg").css("display", "");
      return;
    }

    if (this.objectAddEdit.zipCode != '' && !Formatter.validateZip(this.objectAddEdit.zipCode)) {
      $("#zipCode").addClass("validation-error");
      $("#validationErrorTdDonorDlg").text("Zip code must have 5 or 6 alphanumeric characters");
      $("#validationMsgDonorDlg").css("display", "");
      return;
    }

    //kludge: sometimes if the user deletes everything from the phone number field, there's still a "(" left in the data source property.
    if (this.objectAddEdit.phone == "(")
      this.objectAddEdit.phone = "";

    //If there's a phone number, it must have a valid format
    if (this.objectAddEdit.phone != '' && !Formatter.validatePhone(this.objectAddEdit.phone)) {
      $("#phone").addClass("validation-error");
      $("#validationErrorTdDonorDlg").text("Phone number must have 10 digits");
      $("#validationMsgDonorDlg").css("display", "");
      return;
    }

    if (this.objectAddEdit.federalID != '' && this.objectAddEdit.federalID.length != 10 + (this.objectAddEdit.hasSSN ? 1 : 0)) {
      $("#validationErrorTdDonorDlg").text("Federal ID # must have 9 digits");
      $("#validationMsgDonorDlg").css("display", "");
      $("#federalID").addClass("validation-error");
      return;
    }

    //There's no validation error
    $("#validationMsgDonorDlg").css("display", "none");

    if (this.objectAddEdit.email === '') {
      this.msgBox.show("Confirm", `GiftReporter recommends that an e-mail address is provided for each donor to facilitate electronic delivery of giving acknowledgements and periodic giving statements.  Are you sure that you wish to proceed without an e-mail address?`, true,
        () => {
          this.finishAddEditDonorForReal();
        });
    }
    else {
      this.finishAddEditDonorForReal();
    }
  }

  finishAddEditDonorForReal() {
    //There are no validation errors, so we save to the DB. The API method will return the new list of donors to update the grid.
    this.webService.donors_AddEditDonor(this.objectAddEdit).subscribe(
      apiResponse => {
        if (ApiResponse.checkStatus(apiResponse)) {
          this.modalAddEdit.hide();
          if (this.callbackSave)
            this.callbackSave(apiResponse);
        }
      }
    );
  }

  //Cancel out of the add/edit dailog
  cancelAddEditDonor() {
    this.modalAddEdit.hide();
    // Get rid of validation errors for when the dialog appears next time.
    $("*[data-not-blank-donor-dlg]").each(function (index) {
      $(this).removeClass("validation-error");
    });
    $("#statementCell").removeClass("validation-error");
    $("#email").removeClass("validation-error");
    $("#phone").removeClass("validation-error");
    $("#federalID").removeClass("validation-error");
    $("#zipCode").removeClass("validation-error");
    $("#validationMsgDonorDlg").css("display", "none");

    if (this.callbackCancel)
      this.callbackCancel();
  }

  //This is called when one of the Fed ID radio buttons is clicked. We have to update the mask in the fed ID field to be either SSN or fed ID for businesses.
  //I could not figure out how to bind the radio buttons directly to objectAddEdit.hasSSN like other form fields, so we have to update the data source with an event handler.
  onFedIdRadioChanged(hasSSN: boolean) {
    this.objectAddEdit.hasSSN = hasSSN;
    this.fedIdMask = (hasSSN ? "000-00-0000" : "00-0000000");
  }

  //This is called when one of the Statement radio buttons is clicked.
  //I could not figure out how to bind the radio buttons directly to objectAddEdit.usePaperStatement like other form fields, so we have to update the data source with an event handler.
  onStatementRadioChanged(paper: boolean) {
    this.objectAddEdit.usePaperStatement = paper;
  }

  //Open dialog to choose joint donor
  changeJointDonor() {
    this.modalDonorPicker.showDonorPicker(this.msgBox, //see the definition of showDonorPicker to understand the params being passed in.
      (donorNo: number, donorName: string) => { //this is the callback for when the user selects a donor on the donor picker dialog.
      this.objectAddEdit.jointDonorNo = donorNo;
      this.objectAddEdit.jointDonorName = donorName;
      this.objectAddEdit.jointDonorPrimary = true;
    },
    null,
    () => { //this is the callback for when the user clicks the link to remove the joint donor on the donor picker dialog.
      this.objectAddEdit.jointDonorNo = null;
      this.objectAddEdit.jointDonorName = '';
      this.objectAddEdit.jointDonorPrimary = false;
    },
    this.objectAddEdit.jointDonorNo > 0, this.objectAddEdit.donorNo);
  }

  //This event is called if either the first or last name changes. If we are editing a donor (not adding), and the name changes, and it's different from the original name and different from the last time this event was called, then we show them an information dialog that explains what happens when you change a donor name.
  onNameChanged() {
    let newName: string = this.objectAddEdit.firstName + " " + this.objectAddEdit.lastName;
    if (this.oldDonorName && this.oldDonorName.length > 0 && this.oldDonorName != newName && this.newDonorName != newName)
      this.msgBox.show("Information", "If you change the donor's name, all of the contributions and pledges associated with the old name will now be associated with the new name.", false);
    this.newDonorName = newName;
  }
}
